// extracted by mini-css-extract-plugin
module.exports = {"block":"Loading_block__2wyLv"};